














































































































import { cloneDeep } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import CreateIfEmpty from '../../../../../components/CreateIfEmpty.vue'
import { PlaceholdersOnes, PlaceholdersStack } from '../../../../../components/Editor/components/Toolbar/types'
import {
  AvailableButtonsTypes
} from "../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import MediaItem
  from "../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/Media/components/MediaList/MediaItem.vue";
import { IMessageTemplate } from "../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/types";
import MultiMessageEditorWithMediaInput
  from '../../../../../components/Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import SelectInput from '../../../../../components/Pi/fields/SelectInput/SelectInput.vue'
import PlainMediaPreviewList from "../../../../../components/PlainMediaPreviewList.vue";
import TypeSelect from '../../../../../components/TypeSelect.vue'
import { SelectOption } from '../../../../../logic/types'
import { SplitTags } from "../../../posting/PostPreview/includes/helpers";
import {
  ActivationActionMixin,
  UserActivationAction,
  UserActivationActionMessage,
  UserActivationActionTypeEnum,
  getFlowActionTemplate,
  getMessageActionTemplate,
} from '../../ActivationAction'
import BotFeedbackLimitAlert from "../../components/Limitations/BotFeedbackLimitAlert.vue";
import BotFeedbackLimitsMixin from "../../components/Limitations/BotFeedbackLimitsMixin";

@Component({
  components: {
    PlainMediaPreviewList,
    MediaItem,
    BotFeedbackLimitAlert,
    CreateIfEmpty,
    TypeSelect,
    MultiMessageEditorWithMediaInput,
    SelectInput
  },
  data() {
    return {
      UserActivationActionTypeEnum,
      isMobile,
    }
  }
})
export default class ActionCardAction extends Mixins(ModelSetter, BotFeedbackLimitsMixin, ActivationActionMixin) {
  @VModel() action!: UserActivationAction

  @Prop() flowOptions!: Array<SelectOption>

  @Prop() emptyFlowButtonCallback!: () => void

  @Prop() boardKey!: string

  @Prop() placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() editorButtons!: AvailableButtonsTypes

  isSettingVariantsModalOpen = false

  variants: Array<IMessageTemplate> | null = null

  get targetToUpload() {
    return {
      'target': 'target',
      'target_id': this.boardKey
    }
  }

  get hasMessageText() {
    if (this.action.type === UserActivationActionTypeEnum.Message) {
      return !!this.action.variants.length && !!this.action.variants[0].text.trim()
    }

    return false
  }

  get hasMessageAttachments() {
    if (this.action.type === UserActivationActionTypeEnum.Message) {
      return !!this.action.variants.length && !!this.action.variants[0].attachments.length
    }

    return false
  }

  get messageText() {
    return SplitTags((this.action as UserActivationActionMessage).variants[0].text)
  }

  applyMessageChanges(): void {
    if (this.action.type === UserActivationActionTypeEnum.Message && this.variants) {
      this.action.variants = cloneDeep(this.variants)

      this.variants = null
      this.isSettingVariantsModalOpen = false
    }
  }

  changeText(): void {
    if (this.action.type === UserActivationActionTypeEnum.Message) {
      this.variants = cloneDeep(this.action.variants)

      this.isSettingVariantsModalOpen = true
    }
  }

  onActionItemClick(type: UserActivationActionTypeEnum): void {
    if (type !== this.action.type) {
      this.action.type = type

      if (type === UserActivationActionTypeEnum.Message) {
        this.action = getMessageActionTemplate(this.$i18n)
      } else {
        this.action = getFlowActionTemplate()
      }
    }
  }
}
